import { put } from './requests'

export function switchToFree () {
  return put('billing/switch_to_free')
}

export function switchToPro (frequency) {
  return put('billing/switch_to_pro', { subscription: { frequency } })
}

export function switchPlan (subscription) {
  return put('billing/switch_plan', { subscription })
}

export function billYearly () {
  return put('billing/bill_yearly')
}

export function billMonthly () {
  return put('billing/bill_monthly')
}

export function updatePaymentInfo (token) {
  return put('billing/update_payment_info', { paymentInfo: { token } })
}

export function buyBusinessUpgrade () {
  return put('billing/buy_business_upgrade')
}

export function redeemSumoCodes (codes) {
  return put('billing/redeem_sumo_codes', { subscription: { codes } })
}

export function apiUpgrade () {
  return put('billing/api_upgrade')
}

export function cancelApiSubscription () {
  return put('billing/cancel_api')
}
